<div class="ai-chatbot-message-feedback">
  <button
    type="button"
    class="ai-chatbot-message-feedback-button"
    [class.ai-chatbot-message-feedback-button-active-up]="thumbsUpActive"
    aria-label="Thumbs up"
    (click)="onThumbsUpClick()"
  >
    <mat-icon
      svgIcon="thumbs-up"
      class="ai-chatbot-message-feedback-icon bold small"
      aria-hidden="true"
    ></mat-icon>
  </button>
  <button
    type="button"
    class="ai-chatbot-message-feedback-button"
    [class.ai-chatbot-message-feedback-button-active]="showFeedbackForm"
    aria-label="Thumbs down"
    (click)="onThumbsDownClick()"
  >
    <mat-icon
      svgIcon="thumbs-down"
      class="ai-chatbot-message-feedback-icon bold small"
      aria-hidden="true"
    ></mat-icon>
  </button>
</div>

<div class="ai-chatbot-message-feedback-form" *ngIf="showFeedbackForm">
  <div
    class="ai-chatbot-message-feedback-form-success"
    *ngIf="feedbackSentState"
  >
    <div class="ai-chatbot-message-feedback-form-success-content">
      <span class="ai-chatbot-message-feedback-form-success-text">
        Thanks for the feedback!
      </span>
      <button
        type="button"
        class="ai-chatbot-message-feedback-form-success-close"
        aria-label="Close feedback message"
        (click)="closeFeedbackForm()"
      >
        <mat-icon
          svgIcon="close"
          class="ai-chatbot-message-feedback-form-success-close-icon"
        ></mat-icon>
      </button>
    </div>
  </div>

  <div *ngIf="!feedbackSentState">
    <div class="ai-chatbot-message-feedback-form-header">
      <span class="ai-chatbot-message-feedback-form-header-text">
        Sorry you didn't like this. Please tell us why:
      </span>
      <button
        type="button"
        class="ai-chatbot-message-feedback-form-close"
        aria-label="Close feedback form"
        (click)="closeFeedbackForm()"
      >
        <mat-icon
          svgIcon="close"
          class="ai-chatbot-message-feedback-form-close-icon"
        ></mat-icon>
      </button>
    </div>
    <textarea
      class="ai-chatbot-message-feedback-form-textarea"
      placeholder="Write feedback..."
      [(ngModel)]="feedbackText"
      rows="4"
    ></textarea>
    <button
      type="button"
      class="ai-chatbot-message-feedback-form-send btn btn-primary"
      [disabled]="!feedbackText.trim()"
      (click)="sendFeedback()"
    >
      Send
    </button>
  </div>
</div>
